export enum PortfolioTab {
  ASSETS = 'assets',
  WATCHLIST = 'watchlist',
  ACTIVITY = 'activity',
}

export enum InformationTab {
  INFORMATION = 'information',
  COMMUNITY = 'community',
  ACTIVITY = 'activity',
}

export enum TradeTab {
  BUY = 'buy',
  SELL = 'sell',
  BORROW = 'borrow',
  ORDERS = 'orders',
}

export enum RentTab {
  RENT = 'rent',
  STOP_RENT = 'stop rent',
  CLAIM = 'claim',
}
